/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OriginatingSchemeType = {
    None: 'NONE',
    PensionFund: 'PENSCH',
    ProvidentFund: 'PRDSCH',
    RetirementAnnuity: 'RTRANU',
    Beneficiary: 'BENIFY',
    Benefit: 'BENI',
    Friendly: 'FREND',
    OriginalProductName: 'OTHER'
} as const;
export type OriginatingSchemeType = typeof OriginatingSchemeType[keyof typeof OriginatingSchemeType];


export function OriginatingSchemeTypeFromJSON(json: any): OriginatingSchemeType {
    return OriginatingSchemeTypeFromJSONTyped(json, false);
}

export function OriginatingSchemeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OriginatingSchemeType {
    return json as OriginatingSchemeType;
}

export function OriginatingSchemeTypeToJSON(value?: OriginatingSchemeType | null): any {
    return value as any;
}

